/**
 * WVAD — Acumulação/Distribuição William Variável.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLPriceAndVolume.cs, classe
 * FML.WVAD — ≠ williamsad do odin). Painel próprio, 3 linhas:
 *
 *   WVAD = (C − O) / (H − L) · VOL
 *   MA1  = MA(WVAD, N1)
 *   MA2  = MA(WVAD, N2)
 *
 * Usa VOLUME → desembrulhar o objeto {volume,direction} do indicador Volume no
 * pipeline (família E1). Barras flat (H==L) → 0/0 = NaN. Ordem do engine
 * preservada (div antes de mul). Paridade em __tests__/wvad.silverlight.test.js.
 */
import { sub, div, mul, ma } from "./silverlightDsl";
import { WVAD as defaultOptions } from "./defaultOptionsForComputation";

const unwrapVolume = (raw) =>
  typeof raw === "object" && raw !== null ? raw.volume : raw;

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { n1, n2 } = options;
    const num = (v) => (Number.isFinite(v) ? v : NaN);
    const o = data.map((d) => num(d.open));
    const h = data.map((d) => num(d.high));
    const l = data.map((d) => num(d.low));
    const c = data.map((d) => num(d.close));
    const vol = data.map((d) => num(unwrapVolume(d.volume)));

    // (C-O)/(H-L) * VOL — mesma ordem do engine.
    const wvad = mul(div(sub(c, o), sub(h, l)), vol);
    const ma1 = ma(wvad, n1);
    const ma2 = ma(wvad, n2);

    return wvad.map((w, i) => {
      const wOut = Number.isFinite(w) ? w : undefined;
      const m1 = Number.isFinite(ma1[i]) ? ma1[i] : undefined;
      const m2 = Number.isFinite(ma2[i]) ? ma2[i] : undefined;
      if (wOut === undefined && m1 === undefined && m2 === undefined)
        return undefined;
      return { wvad: wOut, ma1: m1, ma2: m2 };
    });
  }

  calculator.undefinedLength = function () {
    // WVAD começa na barra 0 (por barra); MA1/MA2 acrescentam N-1. Flat bars
    // viram undefined pontualmente (tratadas por barra).
    return 0;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
